// extracted by css-extract-rspack-plugin
export default {"container":"UF01rPHk61QCyCd6","active":"mnyXL9R9AN91078o","content":"lEPiAPpxQrkp2k_v","textContainer":"mSciEBQgQ8E0WDYH","helper":"yCYA3umPsCsFtHrj","footer":"B25SxLKIQq4AnP3K"};